var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedIcondamage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#B91618"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00051 9.31488L10.5898 11.8099C10.8496 12.0621 11.0186 12.0647 11.2831 11.8099L11.8026 11.3092C12.0571 11.064 12.0744 10.9031 11.8026 10.6412L9.06128 8.0001L11.8028 5.35901C12.0596 5.11078 12.0646 4.94326 11.8028 4.6908L11.2833 4.19034C11.0138 3.93059 10.8473 3.94259 10.5901 4.19034L8.00051 6.68532L5.4112 4.19058C5.15394 3.94282 4.98744 3.93082 4.71793 4.19058L4.19842 4.69103C3.93641 4.9435 3.94116 5.11102 4.19842 5.35925L6.93973 8.0001L4.19842 10.6412C3.92666 10.9031 3.94116 11.064 4.19842 11.3092L4.71768 11.8099C4.97994 12.0647 5.14894 12.0621 5.41095 11.8099L8.00051 9.31488Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedIcondamage);
export default __webpack_public_path__ + "static/media/redIcondamage.862e467d8fa59788790019daca9a425a.svg";
export { ForwardRef as ReactComponent };